import { IAdvancedFilter } from '../../interfaces/IAdvancedFilter';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { IModel, Collection, IViolation } from '../base/annotation';
import { Metamodel } from '../base/model';
import { TriggerProperties } from './trigger-properties';

@Metamodel.model({
    name: 'CustomEventsTrigger',
    display: [shellStringResources.Trigger_CustomEvents, shellStringResources.ModelName_CustomEventsTriggers],
    validator: CustomEventsTriggerProperties.prototype.validate
})
export class CustomEventsTriggerProperties extends TriggerProperties {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_ScopeLabel,
        constraint: {
            required: true
        }
    })
    public scope: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_Tenant,
        constraint: {
            required: false
        }
    })
    public tenantId: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_SubjectBeginsWith,
        constraint: {
            required: false
        }
    })
    public subjectBeginsWith?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_SubjectEndsWith,
        constraint: {
            required: false
        }
    })
    public subjectEndsWith?: string;

    @Metamodel.attribute({
        display: shellStringResources.Trigger_Event,
        collection: Collection.Array,
        constraint: {
            minOccurs: 1,
            unique: true
        }
    })
    public events: string[] = [];

    @Metamodel.attribute({
        display: shellStringResources.ModelName_AdvancedFilters,
        collection: Collection.Array,
        constraint: {
            required: false,
            unique: true
        }
    })
    public advancedFilters: IAdvancedFilter[] = [];

    public validate(): IViolation[] | undefined {
        return undefined;
    }
}
